<template>
    <EditDialog :show="visible" :title="title">
        <el-form size="mini" ref="form" :model="form" label-width="80px" :rules="rules">
            <el-form-item label="角色名称" prop="RoleName">
                <el-input v-model="form.RoleName"></el-input>
            </el-form-item>
            <el-form-item label="角色描述" prop="Memo">
                <el-input type="textarea" maxlength="100" show-word-limit v-model="form.Memo"></el-input>
            </el-form-item>
            <el-form-item label="角色权限">
                <div v-for="parent of allPrivList" :key="parent.PrivID">
                    <div style="font-weight: bold">{{ parent.PrivName }}</div>
                    <el-row :gutter="10">
                        <el-col :span="8" v-for="item of parent.Children" :key="item.PrivID">
                            <el-switch v-model="item.Switch" @change="changePriv($event, item.PrivID)" :active-text="item.PrivName" inactive-text="">
                            </el-switch>
                        </el-col>
                    </el-row>
                </div>
            </el-form-item>
        </el-form>
        <template #button>
            <div class="dialog-footer">
                <el-button size="mini" @click="handleSave" style="margin-right: 30px" type="primary">保存</el-button>
                <el-button size="mini" @click="handleClose">取消</el-button>
            </div>
        </template>
    </EditDialog>
</template>

<script>
export default {
    name: "RoleAdd",
    props: {
        visible: {
            type: Boolean,
        },
        editModel: {
            type: Object,
        },
    },
    computed: {
        title() {
            if (this.editModel) {
                return "编辑角色";
            }
            return "新增角色";
        },
    },
    data() {
        return {
            originPrivList: [],
            allPrivList: [],
            form: {
                RoleID: null,
                RoleName: "",
                Memo: "",
                PrivList: [],
            },
            rules: {
                RoleName: [{ required: true, message: "必填项", trigger: "blur" }],
            },
        };
    },
    methods: {
        handleClose() {
            this.form = {
                RoleID: "",
                RoleName: "",
                Memo: "",
                PrivList: [],
            };
            this.handleInit();
            this.$emit("update:visible", false);
        },
        handlePrivilege(privilegeList) {
            let parentNode = privilegeList.filter((item) => !item.ParentID);
            parentNode.forEach((item) => {
                item.Children = privilegeList.filter((cc) => cc.ParentID === item.PrivID);
            });
            this.allPrivList = [...parentNode];
        },
        changePriv($event, privilegeID) {
            if ($event) {
                this.form.PrivList.push(privilegeID);
            } else {
                this.form.PrivList = this.form.PrivList.filter((item) => item !== privilegeID);
            }
            this.$forceUpdate();
        },
        handleSave() {
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    if (this.editModel === null) {
                        this.$ajax.post("SysMgr/AddRole", this.form).then((res) => {
                            this.$success("操作成功");
                            this.$emit("refresh", true);
                            this.handleClose();
                        });
                    } else {
                        this.$ajax.post("SysMgr/ChangeRole", this.form).then((res) => {
                            this.$success("操作成功");
                            this.$emit("refresh", true);
                            this.handleClose();
                        });
                    }
                }
            });
        },
        handleInit() {
            this.originPrivList.map((item) => (item.Switch = false));
            this.form.PrivList.forEach((privID) => {
                let privModel = this.originPrivList.find((item) => item.PrivID === privID);
                if (privModel) {
                    privModel.Switch = true;
                }
            });
        },
    },
    created() {
        this.$ajax.post("/SysMgr/GetAllPrivs").then((res) => {
            this.originPrivList = res.Data;
            this.handleInit();
            this.handlePrivilege(this.originPrivList);
        });
        if (this.editModel) {
            let editModel = { ...this.editModel };
            this.$ajax.post("/SysMgr/GetRolePrivs?id=" + this.editModel.RoleID).then((res) => {
                editModel.PrivList = [...res.Data];
                this.form = { ...this.form, ...editModel };
                this.handleInit();
            });
        }
    },
};
</script>

<style scoped></style>
